import {Organization} from "../types/types";
import {User} from "../types/types";


export const dummyOrganization = {
    id: 1,
    user_id: 2,
    name: "kicks for Causes",
    location: "California",
    category: "sports",
    statement: "chicken",
    volunteers: 0,
    email: "Kicksforsoccer@gmail.com"
}